const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-google-analytics-scripts'] = {
        c: () => require('partner/modules/moe-google-analytics-scripts/moe-google-analytics-scripts.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-google-analytics-scripts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-google-analytics-scripts'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-google-analytics-scripts|moe-google-analytics-scripts'] = {
                c: () => require('partner/modules/moe-google-analytics-scripts/moe-google-analytics-scripts.view.tsx'),
                cn: '__local__-__local__-moe-google-analytics-scripts'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };